import { action } from 'mobx';
import { observer } from 'mobx-react';
import {
    autoinject,
    bind,
    inject,
} from 'Mri.Web.Common';
import * as React from 'react';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown } from 'reactstrap';
import {AppStore} from "../../Core/AppStore";

export interface ILiveChartsSelectorProps {
    onChartNameClick?(chartName: string): void;
    readonly chartNames: string[];
}

@autoinject
@observer
export class LiveChartsSelector extends React.Component<ILiveChartsSelectorProps> {
    public constructor(props: ILiveChartsSelectorProps) {
        super(props);
    }

    public render() {
        return (
            <UncontrolledButtonDropdown>
                <DropdownToggle caret color="primary" className="btn-sm">
                    {this.appStore.storage.liveChartSettings.liveChartSelectedChartName ?? 'Charts'}
                </DropdownToggle>

                <DropdownMenu>
                    {this.props.chartNames?.map(chartName => (
                        <DropdownItem
                            className="text-primary"
                            onClick={e => this.onChartNameClick(e, chartName)}
                            key={chartName}
                        >
                            {chartName}
                        </DropdownItem>
                    ))}
                </DropdownMenu>
            </UncontrolledButtonDropdown>
        );
    }

    @bind
    @action
    private onChartNameClick(event: React.MouseEvent<HTMLElement>, chartName: string) {
        event.preventDefault();

        this.appStore.storage.liveChartSettings.liveChartSelectedChartName = chartName;

        if (this.props.onChartNameClick) this.props.onChartNameClick(chartName);
    }

    @inject
    private appStore!: AppStore;
}
